export var CustomerContactType;
(function (CustomerContactType) {
    CustomerContactType["OFFICE"] = "OFFICE";
    CustomerContactType["DRIVER"] = "DRIVER";
})(CustomerContactType || (CustomerContactType = {}));
